
import React from 'react'

import Paper from 'material-ui/Paper';

import NewCustomer from '../../../../../components/customers/NewCustomer'
import Checkout from '../../../../../components/customers/Checkout'

import { dashboard as ROLES_CONFIG } from '../../../../../config/roles';

export default class Home extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null
    }
  }

  render() {
    return (
      <div id="content">
        <div className="row customRow">
          {
            ROLES_CONFIG.checkin.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-5 col-11 ml-2vw mt-1vw p-0 h-100 customShadow" zDepth={3}>
                <NewCustomer />
              </Paper>
            : null
          }
          {
            ROLES_CONFIG.checkout.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-6 col-12 ml-3vw mt-1vw p-0 h-100 customShadow" zDepth={3}>
                <Checkout />
              </Paper> 
            : null
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./routes/app/routes/dashboard/components/Dashboard.js